import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { HttpService, interceptorsToken } from 'library-explorer';
import { ModuleDTO } from 'src/app/model/moduleDTO.model';
import { HttpParams } from '@angular/common/http';
import { switchMap } from 'rxjs/operators';
import { LessonDTO } from '@app/model/lessonsDTO.model';
import { DataResponse } from '@app/model/data-response.model';

@Injectable({
  providedIn: 'root'
})
export class ModuleService {

  constructor(
    private httpService: HttpService
  ) { }

  public getModules(courseId: string = null, extraParams?: HttpParams): Observable<DataResponse<ModuleDTO>> {
    let params = extraParams || new HttpParams();

    params = params
      .set('active', 'true')
      .set(interceptorsToken.HANDLE_PERMISSION_DENIED_PARAM, 'true');

    if (courseId) {
      params = params.set('parentCourse', courseId);
    }

    return this.httpService.get<DataResponse<ModuleDTO>>('modules', params);
  }
  
  public getAllModules(
    courseId: string = null,
    extraParams: HttpParams = null,
    modules: ModuleDTO[] = [],
    pagination: any = { itemsPerPage: 10, currentPage: 1, offset: 0 }
  ): Observable<ModuleDTO[]> {
    let params = extraParams || new HttpParams();
    params = params
      .set('limit', pagination.itemsPerPage)
      .set('offset', pagination.offset);
    
    return this.getModules(courseId, params).pipe(
      switchMap(res => {
        modules = [...modules, ...res.items];
        
        if (res._meta.maxcount <= modules.length) {
          return of(modules);
        }
        
        pagination.currentPage++;
        pagination.offset = (pagination.currentPage - 1) * pagination.itemsPerPage;
        return this.getAllModules(courseId, params, modules, pagination);
      })
    );
  }

  public getModuleByID(id: string): Observable<ModuleDTO> {
    const params = new HttpParams()
      .set('active', 'true')
      .set('id', id)
      .set(interceptorsToken.HANDLE_PERMISSION_DENIED_PARAM, 'true');

    return this.httpService.get<ModuleDTO>('node', params);
  }

  public getModuleContents(id: string, offset = 0, limit = 20): Observable<DataResponse<LessonDTO>> {
    const params = new HttpParams()
      .set('offset', offset.toString())
      .set('limit', limit.toString());

    return this.httpService.get<DataResponse<LessonDTO>>(`module/${id}/contents`, params);
  }
}
